export default __webpack_public_path__ + "static/media/icon-zero nabialu zero glutenu.1e06bee5.svg";